import { Divider as BaseDivider, Container } from '@material-ui/core'
import appConfigs from 'app/configs/appConfigs'
import React, { useEffect } from 'react'

import { PlanBillingInfoPanel } from './PlanBillingInfoPanel'
import { PlanBillingHistoryPanel } from './PlanBillingHistoryPanel'
import { PlanBillingProvider } from '../usePlanBillingContext'

import usePlanBilling from './usePlanBilling'

export const Divider = (props) => <BaseDivider className="my-24" {...props} />

export default function PlanBillingContent({ isOpenChangePlanDialog }) {
  const {
    state: { planBill, payment, accumulate, isLoading },
    handleFetchPlanAndBilling,
    handleFetchPaymentAddress,
  } = usePlanBilling()

  const fetchPlanAndBilling = () => {
    handleFetchPlanAndBilling()
  }

  useEffect(fetchPlanAndBilling, [])

  return (
    <PlanBillingProvider>
      <Container className="m-0 p-0">
        <div className="space-y-20">
          <PlanBillingInfoPanel
            isOpenChangePlanDialog={isOpenChangePlanDialog}
            planBill={planBill}
            payment={payment}
            accumulate={accumulate}
            isLoading={isLoading}
            onFetchPlanAndBilling={handleFetchPlanAndBilling}
            onFetchPaymentAddress={handleFetchPaymentAddress}
          />
          {appConfigs.enableChangePlan && <PlanBillingHistoryPanel />}
        </div>
      </Container>
    </PlanBillingProvider>
  )
}
